import React from 'react';
import BubbleMenu from './BubbleMenu';
const Navbar: React.FC = () => {
  return <BubbleMenu logo={<span className="font-extrabold tracking-tighter text-lg text-black uppercase" data-id="element-65">
          My100.Builds
        </span>} data-id="element-64" />;
};
export default Navbar;